import { createFileRoute } from '@tanstack/react-router';
import { ValuationsPage } from '../pages/valuations-page';

export const Route = createFileRoute('/valuations')({ component: ValuationsPage });
